import { render, staticRenderFns } from "./InspectorOnlyBadge.vue?vue&type=template&id=3b1ca212&scoped=true"
import script from "./InspectorOnlyBadge.vue?vue&type=script&setup=true&lang=js"
export * from "./InspectorOnlyBadge.vue?vue&type=script&setup=true&lang=js"
import style0 from "./InspectorOnlyBadge.vue?vue&type=style&index=0&id=3b1ca212&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b1ca212",
  null
  
)

export default component.exports